export default "__VITE_ASSET__faf97c3d__"